<div class="page-main-header" [class.open]="open">
    <div class="main-header-right row">
        <div class="main-header-left d-lg-none">
            <div class="logo-wrapper d-flex justify-content-center">
                <img class="svg-icon d-flex justify-content-center"
                     alt="" src="assets/images/{{logo}}" style="width: auto; height: 30px">
            </div>
        </div>
        <div class="mobile-sidebar">
            <div class="media-body text-right switch-sm">
                <label class="switch">
                    <a>
                        <app-feather-icons id="sidebar-toggle" [icon]="'align-left'" (click)="collapseSidebar()">
                        </app-feather-icons>
                    </a>
                </label>
            </div>
        </div>
        <div class="nav-right col">
            <ul style="justify-content: space-between" class="nav-menus" [ngClass]="{'open' : openNav}">
                <div style="position: absolute" class="col-8" [ngStyle]="{'visibility': !showPaymentMessage() ? 'hidden' : ''}" >
                    <div class="marquee">
                        <div style="color: red"> Dear Customer, Your subscription is due for renewal. Kindly make the payment  <a class="payment-color" href="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-
8YL46966WX816621MMWSYSKQ" target="_blank">here</a> before <span>{{showDate()}}</span> to continue with the service.</div>
                    </div>

                </div>
                <div style="position: absolute; right: 0" class="d-flex align-items-center justify-content-end">
                <li>
                    <a href="javascript:void(0)" class="text-dark" toggleFullscreen>
                        <app-feather-icons [icon]="'maximize-2'"></app-feather-icons>
                    </a>
                </li>
                <li class="onhover-dropdown mx-3">
                    <div class="media align-items-center">
                        <img class="align-self-center pull-right img-30 rounded-circle" *ngIf="profile == '' || profile == null" src="assets/images/dashboard/default.png"  alt="">
                        <img class="align-self-center pull-right img-30 rounded-circle" *ngIf="profile != '' && profile != null && !listCheck" style="height: 30px" src="{{imgUrl +'/'+ profile}}"  alt="">
                        <img class="img-30 rounded-circle" *ngIf="profile != '' && listCheck" style="height: 30px" [src]="profile"  alt="">
                    </div>
                    <ul class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
                        <li *ngIf="roleid == '2' || roleid == '3' || roleid == '4' || roleid == '6'"><a [routerLink]="'/settings/profile/view'">
                                <app-feather-icons [icon]="'user'"></app-feather-icons>My Profile
                            </a></li>
                        <li *ngIf="roleid == '5'"><a [routerLink]="'/studentlogin/profile/view'">
                            <app-feather-icons [icon]="'user'"></app-feather-icons>My Profile
                        </a></li>
                        <li><a [routerLink]="'/users/change-password'">
                                <app-feather-icons [icon]="'mail'"></app-feather-icons>Change Password
                            </a></li>
                        <li><a (click)="logout()">
                                <app-feather-icons [icon]="'log-out'"></app-feather-icons>Logout
                            </a></li>
                    </ul>
                </li>
                <li>
                    <h6 *ngIf="['2', '3', '4', '5', '6'].indexOf(roleid) > -1" class="letter mt-2">Welcome {{name}}</h6>
                </li>
                </div>
            </ul>
        </div>
    </div>
</div>
